{
    "Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူး",
    "Reset settings": "ဆက်တင်များကို ပြန်လည်သတ်မှတ်ပါ",
    "Close": "ပိတ်ပါ",
    "Content Adjustments": "အကြောင်းအရာ ချိန်ညှိမှုများ",
    "Adjust Font Size": "ဖောင့်အရွယ်အစားကို ချိန်ညှိပါ",
    "Highlight Title": "ခေါင်းစဉ်ကို အထူးပြုပါ",
    "Highlight Links": "လင့်များကို အထူးပြုပါ",
    "Readable Font": "ဖတ်ရန်လွယ်ကူသော ဖောင့်",
    "Color Adjustments": "အရောင် ချိန်ညှိမှုများ",
    "Dark Contrast": "မှောင်မိုက်သော ကွာခြားမှု",
    "Light Contrast": "အလင်းရောင် ကွာခြားမှု",
    "High Contrast": "မြင့်မားသော ကွာခြားမှု",
    "High Saturation": "မြင့်မားသော အရောင်စွဲမှု",
    "Low Saturation": "နိမ့်သော အရောင်စွဲမှု",
    "Monochrome": "တစ်ရောင်တည်း",
    "Tools": "ကိရိယာများ",
    "Reading Guide": "ဖတ်ရှုရန် လမ်းညွှန်",
    "Stop Animations": "အန်နီမေးရှင်းများကို ရပ်ပါ",
    "Big Cursor": "ကြီးမားသော ကာဆာ",
    "Increase Font Size": "ဖောင့်အရွယ်အစားကို တိုးချဲ့ပါ",
    "Decrease Font Size": "ဖောင့်အရွယ်အစားကို လျှော့ချပါ",
    "Letter Spacing": "အက္ခရာအကြား အကွာအဝေး",
    "Line Height": "စာကြောင်းအမြင့်",
    "Font Weight": "ဖောင့်အလေးချိန်",
    "Dyslexia Font": "Dyslexia ဖောင့်",
    "Language": "ဘာသာစကား",
    "Open Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူးကို ဖွင့်ပါ"
  }
  